import * as React from 'react';
import * as styles from './DealRentTrap.css';

interface IDealRentTrapFooterProps {
  title?: string;
  descr?: string;
}

export const DealRentTrapFooter: React.FC<IDealRentTrapFooterProps> = ({ title, descr }) => {
  return (
    <div className={styles['option-footer']}>
      <span className={styles['item-title']}>{title}</span>
      <br />
      <span>{descr}</span>
    </div>
  );
};
